"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mongoose_1 = __importDefault(require("mongoose"));
var convertToMongooseSchema = function (fields) {
    var schemaDefinition = {};
    fields.forEach(function (field) {
        var fieldName = field.fieldName, fieldType = field.fieldType, required = field.required, defaultValue = field.defaultValue, nestedFields = field.nestedFields;
        var fieldSchema = {
            type: getMongooseType(fieldType),
            required: required,
            default: defaultValue,
        };
        if (nestedFields && nestedFields.length > 0) {
            fieldSchema = [convertToMongooseSchema(nestedFields)];
        }
        schemaDefinition[fieldName] = fieldSchema;
    });
    return new mongoose_1.default.Schema(schemaDefinition);
};
var getMongooseType = function (fieldType) {
    switch (fieldType) {
        case "String":
            return String;
        case "Number":
            return Number;
        case "Boolean":
            return Boolean;
        case "Date":
            return Date;
        case "Integer":
            return Number; // Mongoose does not have a separate Integer type
        case "Array":
            return Array;
        default:
            return String;
    }
};
exports.default = convertToMongooseSchema;
